(function() {
    /**
     * Retrieves the umetadata service endpoint with the props
     * provided. If no explicit umetadata enpoint is available at
     * the properties, fallback to pseudo-hardcoded values.
     *
     * @private
     * @param {object} props - windos.$UPP
     * @return {string} url of the umetadata service
     */
    function getUmetadataEndpoint(props) {
        if (props.URL_UPPLICATION_UMETADATA)
            return props.URL_UPPLICATION_UMETADATA;
        /*
         * FIXME:
         * This tempfix needs to be in place until the autoupdater
         * is able to actually auto-update the properties.js (which
         * currently isn't), once that is solved, this whole
         * function can be replaced directly by the value of
         * window.$UPP.URL_UPPLICATION_UMETADATA
         */
        // Fallback into "self-obtaining" the url
        var apiUrl = props.URL_UPPLICATION_REST_SERVICE;
        var hostName = 'umetadata-dev';
        if (/^https?:\/\/(.*?).upplication.com\//.test(apiUrl))
            hostName = hostName.replace(/\-dev$/, '');
        return 'http://' + hostName + '.upplication.com/api/1';
    }

    /**
     * AngularJS service for interacting with the Umetadata HTTP API server.
     * @class UmetadataApiService
     */
    UmetadataApiService.$inject = [ '$http', '$window' ];
    function UmetadataApiService($http, $window) {
        Object.defineProperties(this, {
            /**
             * @private
             * @property {external:ng.$http} UmetadataApiService#_http
             */
            _$http: { value: $http },
            /**
             * Base URL for all request targeting Umetadata HPTT API
             * @private
             * @property {string} UmetadataApiService#API_ENDPOINT
             */
            API_ENDPOINT: { value: getUmetadataEndpoint($window.$UPP) }
        });

    }

    /**
     * Fetches the Umetadata HTTP API and returns the body of the response.
     * The url of the request must be relative to {@link #apiEndpoint}.
     *
     * @param {Object} req - A $http request config.
     * @return {Promsie<string|object>}
     * @see https://docs.angularjs.org/api/ng/service/$http
     */
    UmetadataApiService.prototype.fetch = function(req) {
        // Build url, and remove any trailing / on the parts
        var url = [ this.API_ENDPOINT, req.url ]
            .map(function(part) { return part.replace(/^\/|\/$/ig, '')})
            .join('/')
        return this._$http(Object.assign({}, req, {
            url: url
        }))
    }

    /**
     * Creates a new session on the Umetadata remote API and returns the
     * token that should be used as Authorization header on every request
     * related with that session.
     * @param {number} childuppId - Id of the childupp starting the session
     * @returns {Promsie<string>} The session token
     */
    UmetadataApiService.prototype.createSession = function(childuppId) {
        if (!childuppId)
            throw new Error('Unkown childuppId');

        return this.fetch({
            method: 'POST',
            url: '/session',
            data: { childuppId: childuppId },
        }).then(function(response) {
            return response.data.trim();
        });
    }

    /**
     * Stores the given pair of property-value for the session identified by
     * token into the umetadata database.
     */
    UmetadataApiService.prototype.storeMetadata = function(token, property, value) {
        var data = {};
        data[property] = value;
        return this.fetch({
            method: 'POST',
            url: '/data',
            headers: { 'Authorization': 'Bearer ' + token },
            data: data,
        })
    }

    var UMETADATA_TOKEN_KEY = 'umetadata.token'

    /**
     * AngularJS service for storing values on the Umetadata backend service.
     * @class UmetadataService
     */
    UmetadataService.$inject = [ '$q', '$timeout', '$window', 'storage', 'config', 'umetadataApiService' ];
    function UmetadataService($q, $timeout, $window, storage, config, umetadataApiService) {
        Object.defineProperties(this, {
            /**
             * @private
             * @property {external:ng.$q} UmetadataService#_$q
             */
            _$q: { value: $q },
            /**
             * @private
             * @property {external:ng.$timeout} UmetadataService#_$timeout
             */
            _$timeout: { value: $timeout },
            /**
             * @private
             * @property {config#getChilduppId} UmetadataService#_getChildUppId
             */
            _getChildUppId: { value: config.getChilduppId.bind(config) },
            /**
             * @private
             * @property {UmetadataApiService} UmetadataService#umetadataApiService
             */
            umetadataApiService: { value: umetadataApiService },
            /**
             * Local cached copy of the cache used for interacting with the umetadata
             * API. Persistance is achieved via localStorage. Changes and retrieves to
             * this variable directly interact with the localStorage.
             * @private
             * @property {string} UmetadataService#_sessionToken
             */
            _sessionToken: {
                get: function() {
                    // For some time, token was being saved directly into the
                    // local storage instead of using the storage service, causing it
                    // to be shared between several childupps running under the same domain.
                    // This allows us to "migrate" the old value (if any)
                    var uppStorageToken = storage.get(UMETADATA_TOKEN_KEY);
                    var badStorageToken = $window.localStorage.getItem(UMETADATA_TOKEN_KEY);
                    if (!uppStorageToken && badStorageToken)
                        storage.set(UMETADATA_TOKEN_KEY, badStorageToken);
                    return uppStorageToken;
                },
                set: function(token) {
                    if (!token)
                        storage.remove(UMETADATA_TOKEN_KEY);
                    else
                        storage.set(UMETADATA_TOKEN_KEY, token);
                },
            },
            /**
             * Promise that once resolved assures that a session has been stablished and
             * a token has been retrieved and persisted
             * @private
             * @property {Promise<void>} UmetadataService#_sessionPromise
             */
            _sessionPromise: { value: null, writable: true },

        });
    }

    /**
     * Retries the toTry function as many times as max defines. For every time the function
     * toTry rejects the promsie it returns, it will wait delay*2 milliseconds before retrying,
     * being the delay value recursively increased.
     *
     * @see {@link https://en.wikipedia.org/wiki/Exponential_backoff}
     *
     * @private
     * @method Umetadata#_exponentialBackoff
     * @param {function} toTry - Returns a promise. This is the function to be retried if fails
     * @param {number} [max=10] - Max number of attemtps before bailing to resolve the promise
     * @param {number} [delay=1] - Time in milliseconds after the first fail and before its reattempt
     * @return {Promise<*>} resolved after toTry resolves with its resolution value
     */
    UmetadataService.prototype._exponentialBackoff = function(toTry, max, delay) {
        var _this = this;
        var deferred = this._$q.defer();
        max = typeof max === 'undefined' ? 20 : max; // Max number of attempts before bailing
        delay = typeof delay === 'undefined' ? 1 : delay; // Delay of the first retry after the first failure

        this._$q.when(toTry())
        .catch(function(error) {
            if (max > 0) {
                return _this._$timeout(function(){}, delay)
                .then(function() { return _this._exponentialBackoff(toTry, --max, delay * 2) })
            } else {
                return _this._$q.reject(error)
            }
        })
        .then(function(result) {
            deferred.resolve(result);
        })
        .catch(function(error) {
            deferred.reject(error);
        })
        return deferred.promise;
    }

    /**
     * Returns a promise that resolves into a umetadata session token.
     *
     * Said token is retrieved as follows:
     * - If a session was previously started on this device and its token was persisted
     *  (to local storage) this method will retrieve said token and resolve with its value.
     * - If no session token is found persisted (on local storage) a new one is requested
     *  to the Umetadata API, persisted (to local storage) and resolve with it.
     *
     * @private
     * @method Umetadata#startSession
     * @return {Promise<void>}
     */
    UmetadataService.prototype.startSession = function() {
        var _this = this
        if (!_this._sessionToken) {
            // No cached version of the sesion token available yet.
            // Get a new session token, persist it and then resolve.
            var _startSession = function(childuppId) {
                return _this.umetadataApiService.createSession(childuppId)
                .then(function(token) {
                    _this._sessionToken = token
                })
            }
            return _this._getChildUppId()
            .then(function(childuppId) {
                return _this._exponentialBackoff(function() {
                    return _startSession(childuppId)
                });
            });
        } else {
            // Cached version is available, store it as the session promise
            return _this._$q.when(_this._sessionToken);
        }
    }

    /**
     * Returns a promise that resovles once {@link #_sessionToken} has been assigned
     * a value.
     *
     * Singleton accesor, lazy init for the local session. If a previous session is available
     * that one will be used, otherwise a new one is started and persisted for future uses.
     *
     * @private
     * @method UmetadataService#session
     * @see {@link UmetadataService#startSession}
     * @return {Promise<void>}
     */
    UmetadataService.prototype.session = function() {
        if (!this._sessionPromise)
            this._sessionPromise = this.startSession();
        return this._sessionPromise;
    }

    /**
     * Invalidates the current session, forcing the next request to create a new one
     * @private
     * @method UmetadataService#invalidateSession
     */
    UmetadataService.prototype.invalidateSession = function() {
        this._sessionPromise = null
        this._sessionToken = null
    }

    /**
     * Stores the given property-value to the current local session and returns a promise
     * that is resovled once the call on the API has been resolved.
     *
     * @private
     * @method Umetadata#store
     * @return {Promise<void>}
     */
    UmetadataService.prototype.store = function(property, value) {
        var _this = this;
        return _this.session().then(function() {
            var store = function() {
                return _this.umetadataApiService
                .storeMetadata(_this._sessionToken, property, value)
                .catch(function(error) {
                    // If the token is being rejected server side...
                    if (error.status === 401 || error.status === 403) {
                        // If any store requests are pending on pararell and both
                        // fail because of this case, both would trigger the session
                        // invalidation, causing only the last one to actually take
                        // efect, as a side efect, all except the last data request
                        // are "lost" (assigned to a session that will never be used again)
                        //
                        // Chechking for the sessionToken allows us to check if "session has
                        // been invalidated", because only the first one to trigger it will
                        // cause it
                        if (_this._sessionToken) {
                             // Invalidate current session, will cause a new session request
                            _this.invalidateSession();
                        }
                        return _this.store(property, value);
                    } else
                        throw error
                })
            };
            return _this._exponentialBackoff(store);
        });
    }

    /**
     * Stores the given platform into the remote umetadata service for the
     * current session.
     * Returns a promise that is resolved once the value has been persisted.
     *
     * @method UmetadataService#storePlatform
     * @param {string} platform - Platform name: android, ios, browser.
     * @return {Promise<void>}
     */
    UmetadataService.prototype.storePlatform = function(platform) {
        if (typeof platform !== 'string')
            return this._$q.reject('platform must be a string, got: ' + typeof platform);
        if (platform !== 'android' && platform !== 'ios' && platform !== 'browser')
            return this._$q.reject('unknown platform: ' + platform);
        return this.store('platform', platform);
    }

    /**
     * Stores the given userId into the remote umetadata service for the
     * current session.
     * Returns a promise that is resolved once the value has been persisted.
     *
     * @method UmetadataService#storeUserId
     * @param {number} userId
     * @return {Promise<void>}
     */
    UmetadataService.prototype.storeUserId = function(userId) {
        if (isNaN(userId))
            return this._$q.reject('userId must be a number, got: ' + typeof userId);
        return this.store('userId', Number(userId));
    }

    /**
     * Stores the given fcmToken into the remote umetadata service for the
     * current session.
     * Returns a promise that is resolved once the value has been persisted.
     *
     * @method UmetadataService#storeFcmToken
     * @param {string} fcmToken
     * @return {Promise<void>}
     */
    UmetadataService.prototype.storeFcmToken = function(fcmToken) {
        if (typeof fcmToken !== 'string')
            return this._$q.reject('fcmToken must be a string, got: ' + typeof fcmToken);
        return this.store('fcmToken', fcmToken);
    }

    /**
     * Stores the given pushPlugin into the remote umetadata service for the
     * current session.
     * Returns a promise that is resolved once the value has been persisted.
     *
     * @method UmetadataService#storePushPlugin
     * @param {string} pushPlugin
     * @return {Promise<void>}
     */
    UmetadataService.prototype.storePushPlugin = function(pushPlugin) {
        if (typeof pushPlugin !== 'string')
            return this._$q.reject('pushPlugin must be a string, got: ' + typeof pushPlugin);
        return this.store('pushPlugin', pushPlugin);
    }

    upp
    .service('umetadataApiService', UmetadataApiService)
    .service('umetadataService', UmetadataService)
})(upp)



// WEBPACK FOOTER //
// ./src/app/common/services/umetadata-service.js